// src/stores/user.js
import { writable } from 'svelte/store';

export const user = writable(null); // Almacena los datos del usuario
